import Vue from 'vue'
import Router from 'vue-router'
import ErrorPage from '@/components/ErrorPage'
import Register from '@/components/Register'
import Home from '@/components/Home'
import Dashboard from '@/components/Dashboard'
import InstructorQuiz from '@/components/instructor/Quiz'
import StudentQuiz from '@/components/student/Quiz'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [     
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },  
    {
      path: '/admin/quiz',
      name: 'QuizList',
      component: InstructorQuiz,
    },      
    {
      path: '/student/quiz',
      name: 'QuizTake',
      component: StudentQuiz,
    },   
    {
      path: '/error/:msg',
      name: 'ErrorPage',
      component: ErrorPage,
      props: true,
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      alias: '/home',
      props: { type: 'home' },
    },
    {
      path: '/how-to-install',
      name: 'Home',
      component: Home,
      alias: '/install',
      props: { type: 'install' },
    },
    {
      path: '/how-to-export',
      name: 'Home',
      component: Home,
      alias: '/export',
      props: { type: 'export' },
    },
    {
      path: '/how-to-import',
      name: 'Home',
      component: Home,
      alias: '/import',
      props: { type: 'import' },
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
    },
  ],
})
